import {createSelector} from 'reselect';
import {RootState} from 'Redux/Reducers/_RootReducer';


export class ContractSelectors {

    private static getElementByContractNumber(elementList: Array<any>, contractNumber: string) {
        if (elementList.length > 0 && contractNumber != null) {
            return elementList.find((value) => value.contractNumber === contractNumber);
        }

        return null;
    }

    /**
     * Selektor na podstawie listy umów oraz id wybranej zwraca obiekt aktualnie wybranej umowy
     *
     * @static
     * @memberof ContractSelectors
     */
    public static getActiveContract = createSelector(
        (state: RootState) => state.contractStore.contractList,
        (state: RootState) => state.contractStore.contractNumberActive,
        ContractSelectors.getElementByContractNumber
    )
}



// WEBPACK FOOTER //
// ./src/Redux/Selectors/ContractSelectors.ts